import styled from 'styled-components';
import {JColors} from 'themes/colors';

export const Container = styled.div`
  box-shadow: -1px 1px 5px 2px rgba(141, 141, 141, 0.24);
  border: solid 0.5px #979797;
  top: 60px;
  right: 0px;
  width: 500px;
  max-width: 100%;
  box-sizing: border-box;
  z-index: 999;
  background-color: ${JColors.white};
  ${(props) => (props.nofly ? ContainerFlyStyle.nofly : ContainerFlyStyle.fly)}
`;

const ContainerFlyStyle = {
  fly: `
    position: absolute;
    height: 600px;
    max-height: calc(100% - 200px);      
  `,
  nofly: `
    position: static;
    height: 100%;
    max-height: 100%;
    border-right: none;
    border-bottom: none;
  `,
};

export default {};
